export interface IMutation {
    position: number,
    units: string[],  // mutated amino acids / nucleotides
}

export interface ICodonMutation {
    positions: number[],
    wildType: {
        dna: string[],
        aminoAcid: string,
    },
    mutation: {
        dna: string[],
        aminoAcid: string,
    },
}

export enum MutationLevelEnum {
    DNA = "DNA",
    Protein = "Protein",
}
